import Entity from "../entity";
export default class EanTicket extends  Entity<number>{
    participacionId: number;
    imagenValidacion: string;
    barcode : string;
}